// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

/* eslint-disable import/prefer-default-export */

/**
 * The message the server attached to one field of a failed response (unpacked by Utils/http into
 * `errors[field]`, e.g. a name that is already taken), or the caller's fallback when the failure
 * carried none.
 */
export const fieldErrorMessage = (response: IApiResponse<unknown>, field: string, fallback: string): string =>
  response.errors?.[field] || fallback;
